import { CLEAR_COMPLAINTS } from '../actions/clear-complaints';

const INITIAL_STATE = [];

export default function complaints(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case 'data-load_FULFILLED': {
      if (payload && payload.key === 'fetchComplaints') {

        return [
          ...state,
          ...payload.response.data,
        ];
      }
      return state;
    }

    case CLEAR_COMPLAINTS: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
}
